import ContactToken from '@apps/crm/admin/tokens/contact'
import DurationToken from '@admin/tokens/duration'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Carts)',
  collection: {
    endpoint: '/api/admin/truevail/admin/signups/carts/expired',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Contact)', key: 'contact.display_name', sort: 'last_name', primary: true, format: ({ contact }) => {
        return <ContactToken { ...contact } />
      } },
      { label: 't(Signup Page)', key: 'signup_page.title', sort: 'signup_page' },
      { label: 't(Agency)', key: 'owner.title', sort: 'agency' },
      { label: 't(Affiliate)', key: 'affiliate.team.title', sort: 'affiliate' },
      { label: 't(Step)', key: 'status', collapsing: true },
      { label: 't(Age)', key: 'age', collapsing: true, wrap: false, align: 'right', format: (signup) => (
        <DurationToken duration={ signup.age } unit="minutes" />
      ) }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'shopping_cart',
      title: 't(No Expired Carts)',
      text: 't(There are no expired carts)'
    },
    entity: 'cart'
  }
})

export default Panel(null, mapPropsToPanel)
